import {
	Column as RiskDetailsColumn,
	headerReactNodes as riskDetailsHeaderReactNodes,
} from './riskDetailsPagination';
import {
	FilterStoreState,
	IdCaption,
	SelectProps,
} from '@innovyze/lib-am-common';

import {
	filterByIdSelect,
	filterByMultipleIdSelect,
} from '@innovyze/lib-am-common/Reducers';
import {
	ATTRIBUTE_FILTER_FIELDS,
	filterByPrecomputed,
} from '@Utils/gridFilterMapping';

const gradeFilterOptions = (): IdCaption[] => [
	{ id: '0', caption: 'Optimal' },
	{ id: '1', caption: 'Stable' },
	{ id: '2', caption: 'Moderate' },
	{ id: '3', caption: 'Concerning' },
	{ id: '4', caption: 'Critical' },
];

const conditionFilterOptions = (): IdCaption[] => [
	{ id: '0', caption: 'No' },
	{ id: '1', caption: 'Yes' },
];

export const riskDetailsInitialState = (): FilterStoreState => {
	const headers = riskDetailsHeaderReactNodes(false, false);
	const grade = headers[RiskDetailsColumn.Grade];
	const condition = headers[RiskDetailsColumn.ConditionData];

	const selects: SelectProps[] = [
		{
			column: { id: condition.key, caption: condition.cell },
			options: conditionFilterOptions(),
			dataCy: condition.key,
			filterBy: filterByIdSelect,
			value: '',
			multiple: false,
		},
		{
			column: { id: grade.key, caption: grade.cell },
			options: gradeFilterOptions(),
			dataCy: grade.key,
			filterBy: filterByMultipleIdSelect,
			value: [],
			multiple: true,
		},
		...ATTRIBUTE_FILTER_FIELDS.map(
			(id): SelectProps => ({
				column: { id, caption: id },
				options: [],
				dataCy: id,
				filterBy: filterByPrecomputed,
				value: '',
				multiple: false,
			}),
		),
	];

	return {
		query: '',
		filters: {},
		selects: selects.reduce((d, v) => ({ ...d, [v.column.id]: v }), {}),
	};
};
